/**
 * usePretreatStats - Pretreat station statistics
 *
 * Auto-refreshes every 30 seconds to show current counts.
 * Uses skipToken to prevent queries with undefined params.
 */
import { trpc } from '@/lib/trpc';
import { useLocation } from '@/contexts/LocationContext';
import { skipToken } from '@tanstack/react-query';

export function usePretreatStats() {
  const { selectedLocation } = useLocation();

  return trpc.pretreat.getStats.useQuery(
    selectedLocation?.id
      ? { locationId: selectedLocation.id }
      : skipToken, // CRITICAL: Prevents query with undefined params
    {
      staleTime: 30_000, // 30s
      refetchInterval: 30_000, // Auto-refresh
    }
  );
}
